import FaqDetails from "./component"

import React, { useEffect ,useState} from "react";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
const FaqDetailsContainer=(props)=>{
  const navigate=useNavigate()
  const { makeApiRequest } = useApiRequest()
  const [orderhistory,setOrderhistory]=useState('')
const [loader,setLoader]=useState(true);
const [topicDetailsList,seTopicDetailsList]=useState([])
const {topicId} =useParams()


    useEffect(()=>{
        FaqDetailsApi()
       
    },[])
    const FaqDetailsApi=()=>{

        const UserJWTAuth = localStorage.getItem("UserJWTAuth");


           makeApiRequest({
       
        url: `${API_BASE_URL}/support/api/v2/faq/topic/${topicId}`,
      method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{
    
        request:{}


      },
      handleSuccess: (res) => handleResponseFaqDetails(res),
      handleError:(error)=> handleErrorFaqDetails(error),
    });
    
      }
    
      const handleErrorFaqDetails=(error)=>{
        //console.log("res")
        setLoader(false)
        if(error.response.status==401|| error.response.status==403){

         // console.log("khan handleErrorVmInventory", error.response.data.status.code);
          //Logout
          //localStorage.removeItem("UserJWTAuth")
          navigate("/login");
      }
      else{ toast.error(`${error.response.data.status.code}`, {
        position: "top-right",
        autoClose: 1000,
      });
      }


        
      }
      
      const  handleResponseFaqDetails=(res)=>{
        console.log("handleResponseFaqDetails-------" )
        seTopicDetailsList(res.data.data)
        setLoader(false)
        
      }








    return(<>
    
    <FaqDetails 
    topicDetailsList={topicDetailsList}/>
    
    </>)
}



export default FaqDetailsContainer
